import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { serverFetch } from 'lib/utils/serverFetch';
import { API } from 'lib/config/axios';
import isCrawlers from 'lib/utils/isCrawlers';
import { AboutUsViewV2 } from 'views/rebranded-module/information-module/AboutUsViewV2';
import { HydrationWrapper } from 'views/common/components';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';
import { useAboutUsCMSData } from 'views/rebranded-module/information-module/AboutUsViewV2/hooks/useAboutUsCMSData';
import { getDeviceType } from 'lib/utils/getDeviceType';

const HistoryPage = (props) => {
  const { serverData } = props;
  const content = useAboutUsCMSData();

  return (
    <HydrationWrapper>
      <ContentContext.Provider value={content?.data}>
        <AboutUsViewV2 serverData={serverData} />
      </ContentContext.Provider>
    </HydrationWrapper>
  );
};
export async function getServerSideProps(ctx) {
  const { locale, req } = ctx;
  let serverError = null;
  let layoutData = null;
  let serverData = null;
  const ssrRender = isCrawlers(ctx.req.headers['user-agent']);
  if (ssrRender) {
    const [layoutRes, seoValuesRes] = await Promise.all([
      serverFetch(ctx, API.layout, ctx.query),
      serverFetch(ctx, API.seoValues, {
        preferred_seo_identifer: 'about-us-history-page',
      }),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
      if (seoValuesRes.success && seoValuesRes.data) {
        serverData = { seo_values: seoValuesRes.data };
      } else {
        serverError = {
          statusCode: seoValuesRes.error.response.status,
        };
      }
    } else {
      serverError = {
        statusCode: layoutRes.error.response.status,
      };
    }
  }
  const hreflangData = generateHreflang(PATHS.history().url, locale);

  const deviceType = getDeviceType(req.headers['user-agent']);

  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_common_main_widget',
        'about_us_page',
      ])),
      serverData,
      hreflangData,
      layoutData,
      serverError,
      ssrRender,
      deviceType,
      rebrandingPage: true,
      options: {
        showAiChat: true,
        transparentNavBar: true,
      },
    },
  };
}
export default HistoryPage;
